import React, { useState } from "react";
import {
  Container,
  Box,
  Dialog,
  DialogContent,
  Typography,
  Button,
  Slide,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import RestaurantCard from "../components/RestaurantCard";
import restaurantsData from "../data/restaurants.json";
import defaultLogo from "../assets/logo-img.png";

const locationOrder = {
  CCU: 1,
  Estoa: 2,
  Rectoría: 3,
};

const restaurants = restaurantsData
  .map((res) => ({
    ...res,
    image: require(`../assets/restaurantes/${res.imageFile}`),
    logo: require(`../assets/restaurantes/${res.logoFile}`),
  }))
  .sort(
    (a, b) =>
      (locationOrder[a.location] || 99) - (locationOrder[b.location] || 99),
  );

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Home = () => {
  const [openInfo, setOpenInfo] = useState(true);
  const [selectedLocation, setSelectedLocation] = useState("Todos");

  const handleClose = () => {
    setOpenInfo(false);
  };

  const filteredRestaurants = restaurants.filter(
    (r) => selectedLocation === "Todos" || r.location === selectedLocation,
  );

  return (
    <Container
      disableGutters
      maxWidth={false}
      sx={{
        maxWidth: { xs: "600px", md: "1200px" }, // Wider container for desktop
        minHeight: "100vh",
        pb: 0, // Removed bottom padding entirely
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: "0 auto",
        backgroundColor: "#fcfcfc",
      }}
    >
      {/* Header with UDEM Banner and Logo */}
      <Box
        sx={{
          width: "100%",
          position: "relative",
          mb: 8,
        }}
      >
        {/* Banner Background */}
        <Box
          sx={{
            height: 160,
            width: "100%",
            backgroundImage: `url(${require("../assets/udem/crgs.jpg")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            borderBottomLeftRadius: "32px",
            borderBottomRightRadius: "32px",
            position: "relative",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        >
          {/* Dark Overlay */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.35)",
              borderBottomLeftRadius: "32px",
              borderBottomRightRadius: "32px",
            }}
          />
        </Box>

        {/* Circular Logo overlapping the bottom */}
        <Box
          sx={{
            position: "absolute",
            bottom: -50,
            left: "50%",
            transform: "translateX(-50%)",
            width: 100,
            height: 100,
            borderRadius: "50%",
            backgroundColor: "white",
            border: "4px solid white",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            zIndex: 2,
          }}
        >
          <img
            src={require("../assets/udem/logo-udem.png")}
            alt="Universidad de Monterrey Logo"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Box>
      </Box>

      {/* Filter Section */}
      <Box
        sx={{
          width: "100%",
          px: { xs: 2, md: 4 },
          mb: 2, // Reduced margin bottom from 4 to 2
          display: "flex",
          justifyContent: "center", // Centered properly
        }}
      >
        <FormControl
          sx={{
            minWidth: 180,
            backgroundColor: "#f0f0f0",
            borderRadius: "8px", // Made it less round (from 24px)
            position: "relative", // Relative for absolute icon positioning
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none", // Remove default border
            },
            "&:hover": {
              backgroundColor: "#e4e4e4",
            },
          }}
        >
          {/* Location Icon inside the select box */}
          <LocationOnIcon
            sx={{
              position: "absolute",
              left: 12,
              top: "50%",
              transform: "translateY(-50%)",
              color: "#1a1a1a",
              fontSize: "1.2rem",
              zIndex: 1,
              pointerEvents: "none", // Don't block clicks
            }}
          />
          <Select
            value={selectedLocation}
            onChange={(e) => setSelectedLocation(e.target.value)}
            displayEmpty
            inputProps={{ "aria-label": "Filtrar por ubicación" }}
            sx={{
              borderRadius: "8px", // Match the parent's less round border
              fontFamily: '"Proxima Nova", Helvetica, Arial, sans-serif',
              fontWeight: "bold",
              color: "#1a1a1a",
              fontSize: "0.95rem",
              "& .MuiSelect-select": {
                paddingTop: "8px", // Reduced padding inside the select box
                paddingBottom: "8px",
                paddingLeft: "38px", // Added extra padding left to make room for the icon
              },
            }}
          >
            <MenuItem
              value="Todos"
              sx={{
                fontFamily: '"Proxima Nova", Helvetica, Arial, sans-serif',
                fontWeight: "bold",
              }}
            >
              Todo el Campus
            </MenuItem>
            <MenuItem
              value="CCU"
              sx={{
                fontFamily: '"Proxima Nova", Helvetica, Arial, sans-serif',
                fontWeight: "bold",
              }}
            >
              CCU
            </MenuItem>
            <MenuItem
              value="Estoa"
              sx={{
                fontFamily: '"Proxima Nova", Helvetica, Arial, sans-serif',
                fontWeight: "bold",
              }}
            >
              Estoa
            </MenuItem>
            <MenuItem
              value="Rectoría"
              sx={{
                fontFamily: '"Proxima Nova", Helvetica, Arial, sans-serif',
                fontWeight: "bold",
              }}
            >
              Rectoría
            </MenuItem>
          </Select>
        </FormControl>
      </Box>

      {/* Restaurant List */}
      <Box
        sx={{
          width: "100%",
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, // 1 column on mobile/tablet, 2 on desktop
          gap: 3,
          px: { xs: 2, md: 4 },
        }}
      >
        {filteredRestaurants.map((restaurant, index) => (
          <RestaurantCard
            key={restaurant.id}
            restaurant={restaurant}
            index={index}
          />
        ))}
      </Box>

      {/* Intro Modal / Pop-up */}
      <Dialog
        open={openInfo}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: "24px",
            padding: "24px 16px",
            maxWidth: "400px",
            width: "90%",
            textAlign: "center",
            boxShadow: "0 12px 32px rgba(0,0,0,0.15)",
          },
        }}
      >
        <DialogContent sx={{ overflowY: "visible", p: 1 }}>
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{ mb: 4, color: "#1a1a1a" }}
          >
            ¿Cómo funciona?
          </Typography>

          <Box
            sx={{ display: "flex", flexDirection: "column", gap: 3.5, mb: 4 }}
          >
            {/* Step 1 */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                textAlign: "left",
                gap: 2,
              }}
            >
              <Box
                sx={{
                  minWidth: 44,
                  height: 44,
                  borderRadius: "50%",
                  backgroundColor: "#FFC800",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  color: "#1a1a1a",
                }}
              >
                1
              </Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  color: "#333",
                  fontSize: "1.1rem",
                  lineHeight: 1.2,
                }}
              >
                Elige tu restaurante favorito
              </Typography>
            </Box>

            {/* Step 2 */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                textAlign: "left",
                gap: 2,
              }}
            >
              <Box
                sx={{
                  minWidth: 44,
                  height: 44,
                  borderRadius: "50%",
                  backgroundColor: "#FFC800",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  color: "#1a1a1a",
                }}
              >
                2
              </Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  color: "#333",
                  fontSize: "1.1rem",
                  lineHeight: 1.2,
                }}
              >
                Selecciona los productos que se te antojen
              </Typography>
            </Box>

            {/* Step 3 */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                textAlign: "left",
                gap: 2,
              }}
            >
              <Box
                sx={{
                  minWidth: 44,
                  height: 44,
                  borderRadius: "50%",
                  backgroundColor: "#FFC800",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  color: "#1a1a1a",
                }}
              >
                3
              </Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  color: "#333",
                  fontSize: "1.1rem",
                  lineHeight: 1.2,
                }}
              >
                Realiza tu pedido ¡y disfruta!
              </Typography>
            </Box>

            {/* Step 4 */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                textAlign: "left",
                gap: 2,
              }}
            >
              <Box
                sx={{
                  minWidth: 44,
                  height: 44,
                  borderRadius: "50%",
                  backgroundColor: "#FFC800",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  color: "#1a1a1a",
                }}
              >
                4
              </Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  color: "#333",
                  fontSize: "1.1rem",
                  lineHeight: 1.2,
                }}
              >
                Ve al local, paga ahí y recoge tu pedido
              </Typography>
            </Box>
          </Box>

          <Button
            fullWidth
            variant="contained"
            onClick={handleClose}
            sx={{
              mt: 2,
              backgroundColor: "#1a1a1a",
              color: "white",
              borderRadius: "16px",
              padding: "14px",
              textTransform: "none",
              fontWeight: "bold",
              fontSize: "1.1rem",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              "&:hover": {
                backgroundColor: "#333",
              },
            }}
          >
            ¡Entendido!
          </Button>
        </DialogContent>
      </Dialog>

      {/* Footer Powered by mennu.mx */}
      <Box
        sx={{
          mt: "auto",
          pt: 2,
          pb: 2,
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <a
          href="https://mennu.mx"
          target="_blank"
          rel="noreferrer"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textDecoration: "none",
            backgroundColor: "#FFFFFF",
            borderRadius: "12px", // Slightly smaller border radius to match smaller size
            padding: "8px 20px", // Reduced padding
            margin: "0 auto",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)", // Softer shadow
            maxWidth: "fit-content",
            gap: "2px", // Tightened gap between text and logo
          }}
        >
          <div
            style={{
              color: "#555555", // Slightly lighter gray so it's less dominant
              fontSize: "11px", // Much smaller font
              fontFamily: '"Montserrat", sans-serif',
              fontWeight: "bold", // Changed to bold
              textAlign: "center",
              whiteSpace: "nowrap",
            }}
          >
            Powered by
          </div>
          <img
            src={defaultLogo}
            alt="Mennu.mx logo"
            style={{
              height: "22px", // Much smaller logo (from 36px)
              width: "auto",
              display: "block",
            }}
          />
        </a>
      </Box>
    </Container>
  );
};

export default Home;
